import React from "react";
import "./sorticons.css";
import {
  setSearchFields,
  fetchFilteredTableDataInit,
  getOperationFilteredDataInit,
  setSeverityFilter,
} from "../../../redux/slices/operationHomeSlice";
import { useDispatch, useSelector } from "react-redux";
import getIntervalParams from "../../Helper/getIntervalParams";

const SortIcons = ({ columnKey, handleSort, sortConfig, transactionTable }) => {
  const dispatch = useDispatch();
  const searchFields = useSelector((state) => state.operationHome.searchFields);
  const pageSize = useSelector((state) => state.operationHome.table.pageSize);
  const activeTab = useSelector((state) => state.operationHome.activeTab);
  const startDate = useSelector((state) => state.operationHome.tabStartDate);
  const endDate = useSelector((state) => state.operationHome.tabEndDate);

  const currentSortKey = searchFields.sort;
  const currentSortDirection = searchFields.sortType;

  const requestSort = (key, direction) => {
    // If clicking the same direction, do nothing (keep it in the same order)
    if (currentSortKey === key && currentSortDirection === direction) return;

    if (transactionTable) {
      dispatch(
        setSearchFields({ ...searchFields, sort: key, sortType: direction })
      );
      handleSort(key, direction);
      return;
    }

    const newSearchFields = {
      ...searchFields,
      sort: key,
      sortType: direction,
    };

    dispatch(setSearchFields(newSearchFields));

    // When column filters are active (searches array format), use
    // getOperationFilteredDataInit so the active filters are included in the
    // sort request. fetchFilteredTableDataInit uses a different payload format
    // that ignores the searches array, causing unfiltered data to be returned.
    if (searchFields.searches && searchFields.searches.length > 0) {
      const params = getIntervalParams(activeTab, startDate, endDate);
      params.limit = pageSize;
      dispatch(
        getOperationFilteredDataInit({
          body: {
            searches: searchFields.searches,
            sort: key,
            sortType: direction,
            page: 1,
          },
          params,
        })
      );
    } else {
      dispatch(
        fetchFilteredTableDataInit({
          pageSize,
          currentPage: 1,
          activeTab,
          startDate,
          endDate,
          searchFields: newSearchFields,
        })
      );
    }
  };

  const getSortClass = (arrow) => {
    if (currentSortKey === columnKey) {
      if (currentSortDirection === "ASC" && arrow === "up")
        return "active-sort-up";
      if (currentSortDirection === "DESC" && arrow === "down")
        return "active-sort-down";
    }
    return "";
  };

  return (
    <div className="sort-icons">
      {/* Ascending Sort Button */}
      <div
        className={`up-arrow ${
          currentSortKey === columnKey && currentSortDirection === "ASC"
            ? "active-sort-up"
            : ""
        }`}
        onClick={
          currentSortKey !== columnKey || currentSortDirection !== "ASC"
            ? () => requestSort(columnKey, "ASC")
            : null
        }
        title="Sort Ascending"
        style={{
          pointerEvents:
            currentSortKey === columnKey && currentSortDirection === "ASC"
              ? "none"
              : "auto",
          opacity:
            currentSortKey === columnKey && currentSortDirection === "ASC"
              ? 0.5
              : 1,
        }}
      ></div>

      {/* Descending Sort Button */}
      <div
        className={`down-arrow ${
          currentSortKey === columnKey && currentSortDirection === "DESC"
            ? "active-sort-down"
            : ""
        }`}
        onClick={
          currentSortKey !== columnKey || currentSortDirection !== "DESC"
            ? () => requestSort(columnKey, "DESC")
            : null
        }
        title="Sort Descending"
        style={{
          pointerEvents:
            currentSortKey === columnKey && currentSortDirection === "DESC"
              ? "none"
              : "auto",
          opacity:
            currentSortKey === columnKey && currentSortDirection === "DESC"
              ? 0.5
              : 1,
        }}
      ></div>
    </div>
  );
};

export default SortIcons;
